<div
  *transloco="let t; read: 'widgets.options'"
  class="xi-modal__container chart-options__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('chart-options') }}</h2>

  <div class="xi-modal__content chart-options__content">
    @if (graphTypeOptions.length > 0) {
      <div class="chart-options__field-container">
        <xi-dropdown
          select="single"
          [label]="t('chart-type')"
          [(value)]="data.payload.graphType"
          [stretch]="true"
          [data]="graphTypeOptions"
          (onValueChange)="setChartTypeChartOption($event.detail.selected.id)"
        ></xi-dropdown>
      </div>
    }
    @if (currentReport.getChartSettings().length > 0) {
      <div class="chart-options__field-container">
        @for (optGroup of currentReport.getChartSettings(); track optGroup) {
          @switch (optGroup.type) {
            @case ('singleSelect') {
              <xi-dropdown
                select="single"
                [label]="optGroup.groupLabel"
                [value]="data.payload[optGroup.property]"
                [stretch]="true"
                [data]="chartSettingsOptions[optGroup.property]"
                (onValueChange)="
                  setChartOption(optGroup.property, $event.detail.selected.id, optGroup.needRefresh)
                "
              ></xi-dropdown>
            }
            @case ('toggle') {
              <div class="chart-options__percentage-toggle">
                @if (optGroup.shouldDisplay?.(data) ?? true) {
                  <xi-toggle-switch
                    [label]="optGroup.groupLabel"
                    [isLabelLeft]="true"
                    [isToggled]="data.payload[optGroup.property] === true"
                    [leftText]="optGroup.leftText"
                    [rightText]="optGroup.rightText"
                    (onToggle)="setChartOption(optGroup.property, $event.detail.isToggled)"
                  ></xi-toggle-switch>
                }
              </div>
            }
            @default {
              @if (optGroup.shouldDisplayOptions?.(optGroup.settings, data) ?? true) {
                <div class="chart-options__group-label">
                  <label [id]="optGroup.groupId">{{ optGroup.groupLabel }}</label>
                </div>
              }
              <div class="chart-options__default-group">
                @for (setting of optGroup.settings; track setting) {
                  @if (setting.type === 'checkbox' && (setting.shouldDisplay?.(data) ?? true)) {
                    <mat-checkbox
                      class="chart-options__checkbox"
                      [(ngModel)]="data.payload[optGroup.property][setting.property]"
                      [disabled]="setting.group && optGroup.groupValidator(data.payload.graphType)"
                      (ngModelChange)="
                        setChartOption(
                          optGroup.property + '.' + setting.property,
                          $event,
                          optGroup.needRefresh
                        )
                      "
                    >
                      {{ setting.label }}
                    </mat-checkbox>
                  }
                  @if (setting.type === 'toggle' && setting.shouldDisplay(data)) {
                    <div class="chart-options__percentage-toggle">
                      <xi-toggle-switch
                        [label]="setting.label"
                        [isLabelLeft]="true"
                        [isToggled]="data.payload[optGroup.property][setting.property] === true"
                        [leftText]="setting.leftText"
                        [rightText]="setting.rightText"
                        (onToggle)="
                          setChartOption(
                            optGroup.property + '.' + setting.property,
                            $event.detail.isToggled
                          )
                        "
                      ></xi-toggle-switch>
                    </div>
                  }
                  @if (setting.type === 'singleSelect' && setting.shouldDisplay(data)) {
                    <div class="chart-options__single-select-dropdown-wrapper">
                      <label [for]="setting.property" class="kxi-text-small">{{
                        setting.label
                      }}</label>
                      <div
                        [class.chart-options__single-select-dropdown--narrow]="
                          setting.condensedDisplay
                        "
                      >
                        <xi-dropdown
                          [id]="setting.property"
                          select="single"
                          [value]="data.payload[optGroup.property][setting.property]"
                          [disabled]="!!setting.isDisabled(data)"
                          [stretch]="true"
                          [data]="chartSettingsOptions[optGroup.property + '.' + setting.property]"
                          [visualState]="setting.condensedDisplay"
                          (onValueChange)="
                            setChartOption(
                              optGroup.property + '.' + setting.property,
                              $event.detail.selected.id,
                              optGroup.needRefresh
                            )
                          "
                        >
                        </xi-dropdown>
                      </div>
                    </div>
                  }
                }
              </div>
            }
          }
        }
      </div>
    }
    @if (canShowAsStacked) {
      <div class="chart-options__field-container">
        <xi-toggle-switch
          [isToggled]="data.payload.showAsStacked"
          [isLabelLeft]="true"
          [label]="t('show-as-stacked-chart')"
          (onToggle)="setChartOption('showAsStacked', $event.detail.isToggled)"
        ></xi-toggle-switch>
      </div>
    }
    @if (aggregatorOptions.length > 1 && !canShowBucketDisplayedAs) {
      <div class="chart-options__field-container">
        <xi-dropdown
          select="single"
          [label]="t('displayed-as')"
          [value]="data.payload.aggregator"
          [stretch]="true"
          [data]="aggregatorOptions"
          (onValueChange)="setAggregatorChartOption($event.detail.selected.id)"
        ></xi-dropdown>
      </div>
    }
    @if (canShowBucketDisplayedAs) {
      <div class="chart-options__field-container">
        <xi-dropdown
          select="single"
          [label]="t('displayed-as')"
          [value]="bucketDisplayedAsSelectedId"
          [stretch]="true"
          [data]="bucketDisplayedAsOptions"
          (onValueChange)="setBucketDisplayedAsChartOption($event.detail.selected.id)"
        ></xi-dropdown>
      </div>
    }
    @if (hasTimeInterval) {
      <div class="chart-options__field-container">
        <xi-dropdown
          select="single"
          [placeholder]="t('select-time-interval')"
          [label]="t('time-interval')"
          [value]="data.payload.dateInterval"
          [stretch]="true"
          [data]="timeIntervalOptions"
          [disabled]="timeIntervalOptionsDisabled"
          (onValueChange)="onDateIntervalChange($event.detail.selected.id)"
        ></xi-dropdown>
      </div>
    }
    @if (hasTimeInterval && data.payload.dateInterval === 'week') {
      <div class="chart-options__field-container">
        <xi-toggle-switch
          [label]="t('show-week-prefix')"
          [isLabelLeft]="false"
          [isToggled]="data.payload.showWeekPrefix !== false"
          color="CX"
          (onToggle)="setChartOption('showWeekPrefix', $event.detail.isToggled)"
        ></xi-toggle-switch>
      </div>
    }
    @if (canDisplayChartValues || canColorByPoint) {
      <div class="chart-options__field-container chart-options__field-container--flex">
        @if (canDisplayChartValues) {
          <xi-checkbox
            color="CX"
            [label]="t('display-values')"
            [checked]="data.payload.displayChartValues"
            [disabled]="isDisplayChartValuesDisabled"
            [tooltip]="{
              text: isDisplayChartValuesDisabled ? displayChartValuesDisabledTooltip : '',
            }"
            (onChange)="setChartOption('displayChartValues', $event.detail.target.checked)"
          ></xi-checkbox>
        }
        @if (canColorByPoint) {
          <xi-checkbox
            color="CX"
            [label]="t('color-by-point')"
            [checked]="data.payload.colorByPoint"
            [disabled]="isColorByPointDisabled"
            [tooltip]="{ text: isColorByPointDisabled ? colorByPointDisabledTooltip : '' }"
            (onChange)="setChartOption('colorByPoint', $event.detail.target.checked)"
          ></xi-checkbox>
        }
      </div>
    }
    @if (isScatterPlot) {
      <div class="chart-options__field-container">
        <xi-dropdown
          select="single"
          [placeholder]="t('select-x-axis')"
          [label]="t('x-axis')"
          [value]="data.payload.xAxis"
          [stretch]="true"
          [data]="scatterAxes"
          (onValueChange)="setScatterAxisChartOption('xAxis', $event.detail.selected.id)"
        ></xi-dropdown>
      </div>
    }
    @if (errorMessages.has('scatterAxes')) {
      <ng-container
        *ngTemplateOutlet="errorTemplate; context: { $implicit: errorMessages.get('scatterAxes') }"
      ></ng-container>
    }
    @if (canSetChartMaximumHorizontal) {
      <div class="chart-options__field-container">
        <xi-input-field
          [label]="t('maximum-x-axis')"
          name="chartMaximumHorizontal"
          [ngModel]="data.payload.chartMaximumHorizontal"
          (ngModelChange)="setChartOption('chartMaximumHorizontal', $event)"
          type="number"
        >
        </xi-input-field>
      </div>
    }
    @if (canSetChartMaximum && showAxes) {
      <div class="chart-options__field-container chart-options__axes-container">
        <span class="chart-options__axes">{{ t('axes') }}</span>
        <div class="chart-options__axes-row">
          <xi-dropdown
            [width]="160"
            [label]="t('primary-axis-values')"
            [data]="primaryAxisValues"
            [value]="chartAxisValue"
            (onValueChange)="setChartAxisValueOption($event.detail.selected.id)"
          ></xi-dropdown>
          <div [matTooltip]="data.payload.chartMinimum">
            <xi-input-field
              [label]="t('min')"
              type="number"
              [disabled]="isDefaultPrimaryAxis"
              [ngModel]="data.payload.chartMinimum"
              (ngModelChange)="setChartOption('chartMinimum', $event); validatePrimaryAxisValues()"
            >
            </xi-input-field>
          </div>
          <div [matTooltip]="data.payload.chartMaximum">
            <xi-input-field
              [label]="t('max')"
              type="number"
              [disabled]="isDefaultPrimaryAxis"
              [ngModel]="data.payload.chartMaximum"
              (ngModelChange)="setChartOption('chartMaximum', $event); validatePrimaryAxisValues()"
            >
            </xi-input-field>
          </div>
          <div [matTooltip]="data.payload.chartInterval">
            <xi-input-field
              [label]="t('interval')"
              type="number"
              [disabled]="isDefaultPrimaryAxis"
              [ngModel]="data.payload.chartInterval"
              (ngModelChange)="setChartOption('chartInterval', $event); validatePrimaryAxisValues()"
            >
            </xi-input-field>
          </div>
        </div>
      </div>
    }
    @if (errorMessages.has('maxHigherThanMin')) {
      <ng-container
        *ngTemplateOutlet="
          errorTemplate;
          context: { $implicit: errorMessages.get('maxHigherThanMin') }
        "
      ></ng-container>
    }
    @if (errorMessages.has('intervalTooLarge')) {
      <ng-container
        *ngTemplateOutlet="
          errorTemplate;
          context: { $implicit: errorMessages.get('intervalTooLarge') }
        "
      ></ng-container>
    }
    @if (isScatterPlot) {
      <div class="chart-options__field-container">
        <xi-dropdown
          select="single"
          [placeholder]="t('select-y-axis')"
          [label]="t('y-axis')"
          [value]="data.payload.yAxis"
          [stretch]="true"
          [data]="scatterAxes"
          (onValueChange)="setScatterAxisChartOption('yAxis', $event.detail.selected.id)"
        ></xi-dropdown>
      </div>
    }
    @if (canSetChartMaximum && !showAxes) {
      <div class="chart-options__field-container">
        <div class="chart-options__maximum-row">
          <xi-input-field
            [label]="isScatterPlot ? t('maximum-y-axis') : t('maximum-numeric-axis')"
            name="chartMaximum"
            [ngModel]="data.payload.chartMaximum"
            (ngModelChange)="setChartOption('chartMaximum', $event); validateChartGoalOptions()"
            (keyup)="onKeyUp('chartMaximum', $event)"
            type="number"
          ></xi-input-field>
          @if (canSetChartMaximumPercentage) {
            <xi-input-field
              [label]="t('maximum-percentage-axis')"
              name="chartMaximumPercentage"
              [ngModel]="data.payload.chartMaximumPercentage"
              (ngModelChange)="setChartOption('chartMaximumPercentage', $event)"
              (keyup)="onKeyUp('chartMaximumPercentage', $event)"
              type="number"
            ></xi-input-field>
          }
        </div>
      </div>
    }
    @if (canShowSecondaryAxis) {
      <div class="chart-options__field-container chart-options__field-row secondary-axis-toggle">
        <span>
          <h5>{{ t('secondary-axis') }}</h5>
        </span>
        <xi-toggle-switch
          [color]="'admin'"
          changeColorOnToggle="true"
          [tooltip]="{ text: secondaryAxisToggleDisabledText }"
          [disabled]="isSecondaryAxisToggleDisabled"
          [isToggled]="data.payload.hasSecondaryAxis"
          (onToggle)="onSecondaryAxisToggle($event.detail.isToggled)"
        >
        </xi-toggle-switch>
      </div>
    }
    @if (data.payload.hasSecondaryAxis) {
      <div class="chart-options__field-container chart-options__axes-container">
        <div class="chart-options__axes-row">
          <xi-dropdown
            [width]="160"
            [label]="t('secondary-axis-values')"
            [data]="primaryAxisValues"
            [value]="chartSecondaryAxisValue"
            (onValueChange)="setChartAxisSecondaryValueOption($event.detail.selected.id)"
          ></xi-dropdown>
          <div [matTooltip]="data.payload.chartSecondaryMinimum">
            <xi-input-field
              [label]="t('min')"
              type="number"
              [disabled]="isDefaultSecondaryAxis"
              [ngModel]="data.payload.chartSecondaryMinimum"
              (ngModelChange)="setChartSecondaryOption('chartSecondaryMinimum', $event)"
            >
            </xi-input-field>
          </div>
          <div [matTooltip]="data.payload.chartSecondaryMaximum">
            <xi-input-field
              [label]="t('max')"
              type="number"
              [disabled]="isDefaultSecondaryAxis"
              [ngModel]="data.payload.chartSecondaryMaximum"
              (ngModelChange)="setChartSecondaryOption('chartSecondaryMaximum', $event)"
            >
            </xi-input-field>
          </div>
          <div [matTooltip]="data.payload.chartSecondaryInterval">
            <xi-input-field
              [label]="t('interval')"
              type="number"
              [disabled]="isDefaultSecondaryAxis"
              [ngModel]="data.payload.chartSecondaryInterval"
              (ngModelChange)="setChartSecondaryOption('chartSecondaryInterval', $event)"
            >
            </xi-input-field>
          </div>
        </div>
      </div>
    }
    @if (errorMessages.has('maxHigherThanMinSecondary')) {
      <ng-container
        *ngTemplateOutlet="
          errorTemplate;
          context: { $implicit: errorMessages.get('maxHigherThanMinSecondary') }
        "
      ></ng-container>
    }
    @if (errorMessages.has('intervalTooLargeSecondary')) {
      <ng-container
        *ngTemplateOutlet="
          errorTemplate;
          context: { $implicit: errorMessages.get('intervalTooLargeSecondary') }
        "
      ></ng-container>
    }
    @if (canSetChartGoal) {
      <div class="chart-options__field-container chart-options__field-row">
        <div>
          <label class="kxi-input-label kxi-normal-contrast">{{ t('goal') }}</label>
          <input
            #chartGoalInput
            appNumericInput
            allowNegative="true"
            allowFractional="true"
            decimals="1"
            [keepLastValid]="false"
            class="kxi-input kxi-border kxi-text-normal"
            [ngModel]="data.payload.chartGoal"
            (ngModelChange)="setChartGoalOption($event, chartGoalInput)"
          />
        </div>
        <xi-input-field
          [label]="t('display-as')"
          name="chartGoalDisplayAs"
          [ngModel]="data.payload.chartGoalDisplayAs"
          (ngModelChange)="setChartOption('chartGoalDisplayAs', $event)"
          [maxLength]="20"
          type="text"
        >
        </xi-input-field>
        <div class="chart-options__color-picker-field">
          <label class="kxi-input-label kxi-normal-contrast">{{ t('color') }}</label>
          <div class="chart-options__color-picker-wrapper">
            <xi-color-picker
              [direction]="6"
              [selectedColor]="chartGoalColor"
              [preselectedColors]="projectColors"
              (onColorChange)="chartGoalColorChange$.next($event.detail.color)"
            >
            </xi-color-picker>
          </div>
        </div>
      </div>
    }
    @if (errorMessages.has('goalHigherThanMaximumAxisValue')) {
      <ng-container
        *ngTemplateOutlet="
          errorTemplate;
          context: { $implicit: errorMessages.get('goalHigherThanMaximumAxisValue') }
        "
      ></ng-container>
    }
    @if (canSetChartGoal) {
      <div class="chart-options__field-container">
        <label class="kxi-input-label kxi-normal-contrast">{{ t('shade') }}</label>
        <div class="chart-options__field-radiogroup">
          @for (shadeOption of chartGoalShadeOptions; track shadeOption) {
            <xi-radio
              [value]="shadeOption.id"
              [label]="shadeOption.title"
              [checked]="data.payload.chartGoalShade === shadeOption.id"
              (onChange)="setChartOption('chartGoalShade', shadeOption.id)"
            ></xi-radio>
          }
        </div>
      </div>
    }
    @if (canSetDateMarkers) {
      <form
        [formGroup]="dateMarkerForm"
        class="chart-options__field-container chart-options__date-markers-container"
      >
        <div class="chart-options__date-markers-header">
          <label class="kxi-input-label kxi-normal-contrast">{{ t('date-markers') }}</label>
          <xi-icon-button
            icon="add_circle"
            [disabled]="isAddDateMarkerDisabled"
            (onClick)="onAddDateMarker()"
          ></xi-icon-button>
        </div>
        @if (!dateMarkers.controls.length) {
          <div class="chart-options__date-markers-empty-text">
            {{ t('date-markers-empty-text') }}
          </div>
        }
        @if (dateMarkers.controls.length) {
          <ng-container formArrayName="dateMarkers">
            @for (dateMarkerGroup of dateMarkers.controls; track dateMarkerGroup; let i = $index) {
              <div [formGroup]="dateMarkerGroup" class="chart-options__date-marker-row">
                <div class="chart-options__date-picker-wrapper">
                  <xi-date-picker
                    [label]="t('date')"
                    [placeholder]="t('select-date')"
                    formControlName="date"
                    [dateValue]="dateMarkerGroup.controls.date.value"
                    [direction]="11"
                  ></xi-date-picker>
                </div>
                <xi-input-field
                  [label]="t('display-name')"
                  formControlName="displayName"
                ></xi-input-field>
                <div class="chart-options__color-picker-field">
                  <label class="kxi-input-label kxi-normal-contrast">{{ t('color') }}</label>
                  <div class="chart-options__color-picker-wrapper">
                    <xi-color-picker
                      [direction]="6"
                      [selectedColor]="dateMarkerGroup.controls.color.value"
                      [preselectedColors]="projectColors"
                      (onColorChange)="
                        dateMarkerColorChange$.next({ index: i, color: $event.detail.color })
                      "
                    ></xi-color-picker>
                  </div>
                </div>
                <xi-icon-button
                  icon="cancel_circle"
                  (onClick)="onRemoveDateMarker(i)"
                ></xi-icon-button>
              </div>
            }
          </ng-container>
        }
      </form>
    }

    <ng-template #errorTemplate let-errorMessage>
      <div class="chart-options__field-container">
        <p class="error-message">
          {{ errorMessage }}
        </p>
      </div>
    </ng-template>
  </div>

  <div class="xi-modal__actions chart-options__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('apply')"
      [disabled]="isChartOptionsApplyDisabled()"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
